import { writable } from 'svelte/store'
import { Scene } from 'three'

export const previewScene = writable<Scene>()
export const setPreviewScene = (value: Scene) =>
  previewScene.set(value)
